var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.042 10L3.808 4.96L0.196 0.129999H1.876L4.634 3.896L7.364 0.129999H9.058L5.446 4.96L9.198 10H7.504L4.62 6.052L1.75 10H0.042Z",
    fill: "#D20A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/crossIcon.8b5da3d6395925dc40b14e2fd5598232.svg";
export { ForwardRef as ReactComponent };